import StoreAddress from '@components/storelocator/StoreAddress';
import React from 'react';
const BookAnAppointmentStore = (props) => {
    return (React.createElement("div", { className: "baa-storelist__item" },
        React.createElement("div", { className: "baa-storelist__item-title" },
            props.index + 1,
            ". ",
            props.store.name),
        React.createElement(StoreAddress, { store: props.store, hidename: true, split: true })));
};
export default BookAnAppointmentStore;
